import { apiClient } from '../../config/axios-client'
import type { ActivityAction } from '../../shared/enums/ActivityAction'
import type { GenerationStatus } from '../../shared/enums/GenerationStatus'
import type { Commercial, CommercialUpsert } from '../../shared/models/Commercial'

export const commercialsApi = {
  list: (skip: number, top: number, filter?: Record<string, unknown>) =>
    apiClient.get<Commercial[]>('commercials', {
      params: { skip, top, ...filter },
    }),

  count: (filter?: Record<string, unknown>) =>
    apiClient.get<number>('commercials/count', {
      params: { ...filter },
    }),

  detail: (id: string) => apiClient.get<Commercial>(`commercials/${id}`),

  create: (data: CommercialUpsert) => apiClient.post<{ id: string }>('commercials', data),

  update: (id: string, data: CommercialUpsert) =>
    apiClient.patch<Commercial>(`commercials/${id}`, data),

  delete: (id: string) => apiClient.delete<unknown>(`commercials/${id}`),

  status: (commercialId: string, action?: ActivityAction) =>
    apiClient.get<{ status: GenerationStatus }>(`commercials/${commercialId}/status`, {
      params: { action },
    }),
}
